import React, { Component } from 'react';
import logo from '../imgs/et2logo.png';
import {Button, Icon, Input, Radio} from 'antd';
import {historyPush, request, secToTime,requestAdminFormData} from '../utils/Util';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/evaluation';
import myEmitter from "../component/my-events";
import Item from "./Item";
import Ranking from "./Ranking";

import './WrongQuestions.css';
import {Route, Switch} from "react-router-dom";
import ViewResult from "../home/ViewResult";

const RadioGroup = Radio.Group;
const ButtonGroup = Button.Group;
// const Option = Select.Option;

class WrongQuestions extends Component {
    constructor(props) {
        super(props);
        // 初始状态
        this.state = {
            current: 1,
            data: [],
            time: 1800,
            count: 0,
            timeText: '30:00',
            ToolsValue:'',
            DraggableFlag: false,
            selectedOption: null,
        };
    }



    // async getData(){
    //     const {actions,match} = this.props;
    //     const questions = await request(`/questionnaires/test_record/`,'get',{test_id:22649,pages:1});
    //     actions.setAnalysisEvaluation(questions.detail);
    //     actions.setCurrentEvaluation({page: 0});
    //     this.setState({count:questions.detail.count})
    //     console.log(questions);
    // }
    //


    componentDidMount() {
        // this.getData();
    }


    render() {
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
        };
        const {data} = this.state;
        return (
            <div className='question'>
                <header>
                    <div className='header_lf'>
                        <img src={logo} alt=""/>
                    </div>
                    <div className='header_rt'>

                    </div>
                </header>
                <section>
                    <Route exact path="/viewResult/wrong/ranking/:id" component={Ranking}/>
                    <Route exact path="/viewResult/wrong/" component={Item}/>
                </section>
                <aside>


                </aside>
            </div>
        );
    }
}


WrongQuestions = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer.answers
}), (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
}))(WrongQuestions);
export default WrongQuestions;
